import { Component } from '@angular/core';
import { CognitoService } from '@dash/randy/security/service/cognito.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent {
  constructor(private cognitoService: CognitoService, private route: ActivatedRoute, private router: Router) {
    this.route.url.subscribe(async params => {
      const path = params[1].path;
      switch (path) {
        case 'login':
          await this.handleLogin();
          break;
        case 'logout':
          if (this.cognitoService.isAuthenticated()) {
            await this.cognitoService.signOut();
          } else {
            await this.router.navigate(['/login']);
          }
          break;
      }
    });
  }

  private async handleLogin() {
    const loggedIn = await this.cognitoService.handleCallBack();
    if (loggedIn && (await this.cognitoService.completeAccountSecurityCallback())) {
      return;
    }
    await this.router.navigate([loggedIn ? '/choose-application' : '/login']);
  }
}
